module.exports = __webpack_public_path__ + "img/hof_2.cfa09fe7.jpg";